export default {"src":"/_next/static/media/X-Twitter_Black.6186245e.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};